import { render, staticRenderFns } from "./SettingsComponent.vue?vue&type=template&id=03e58503&scoped=true"
import script from "./SettingsComponent.vue?vue&type=script&lang=js"
export * from "./SettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./SettingsComponent.vue?vue&type=style&index=0&id=03e58503&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e58503",
  null
  
)

export default component.exports